import { Companion_getInstanceno8hzdksos3n as Companion_getInstance } from '../type/GraphQLBoolean.mjs';
import {
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstance8d9dd8emdwrf as Companion_getInstance_0 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeletePlayerMutationSelectionsClass;
function DeletePlayerMutationSelections() {
  if (DeletePlayerMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        DeletePlayerMutationSelections_instance = this;
        this.i6r_1 = listOf((new (Builder())('deletePlayer', Companion_getInstance().o70_1)).p47(listOf((new (Builder_0())(Companion_getInstance_0().l6p_1)).a48(new (CompiledVariable())('input')).l38())).l38());
      }
    }
    initMetadataForObject($, 'DeletePlayerMutationSelections');
    DeletePlayerMutationSelectionsClass = $;
  }
  return DeletePlayerMutationSelectionsClass;
}
var DeletePlayerMutationSelections_instance;
function DeletePlayerMutationSelections_getInstance() {
  if (DeletePlayerMutationSelections_instance === VOID)
    new (DeletePlayerMutationSelections())();
  return DeletePlayerMutationSelections_instance;
}
//region block: exports
export {
  DeletePlayerMutationSelections_getInstance as DeletePlayerMutationSelections_getInstance10ni6ckd89zp3,
};
//endregion

//# sourceMappingURL=DeletePlayerMutationSelections.mjs.map
